import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { basketQueries } from '@as-react/common-queries';
import { RoutePathname } from '@as-react/common-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router';
import { LockedBasketNotificationMessage } from '../../components/notification-message/LockedBasketNotificationMessage';
import { DELAY } from '../../constants/GeneralConstants';
import { CheckoutProvider } from '../../context/CheckoutContext';
import { CheckoutDeliveryProvider } from '../../context/CheckoutDeliveryContext';
import { CheckoutPaymentProvider } from '../../context/CheckoutPaymentContext';
import { CheckoutStep } from '../../context/CheckoutStepContext';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useSaferpayDeviceFingerPrinting as UseSaferpayDeviceFingerPrinting } from '../../hooks/useSaferpayDeviceFingerPrinting';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import { makeGetPathname } from '../../redux/router/selectors/RouterSelector';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { makeGetSessionState } from '../../redux/session/selectors/SessionSelector';
import { mimicDelay } from '../../util/GeneralUtil';
import { ScrollUtil } from '../../util/ScrollUtil';
import { CheckoutDeliveryContainer } from './CheckoutDeliveryContainer';
import { CheckoutLayoutContainer } from './CheckoutLayoutContainer';
import { CheckoutLoginContainer } from './CheckoutLoginContainer';
import { CheckoutLoginContainerNewAuth } from './CheckoutLoginContainerNewAuth';
import { CheckoutPaymentContainer } from './CheckoutPaymentContainer';
const CheckoutContainer = props => {
    const { defaultRequestParams, servicesEndpoint, saferpayConfig, rootWithLanguageSuffix, root } = useAemConfig();
    const isFirstRender = useRef(true);
    const [shouldRender, setShouldRender] = useState(false);
    const sessionState = useSelector(makeGetSessionState());
    const pathname = useSelector(makeGetPathname());
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const dispatch = useDispatch();
    const { getBasketBasic } = basketQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: basketBasic, refetch: basketBasicRefetch } = useQuery(getBasketBasic());
    useEffect(() => {
        if (!isNewAuth) {
            dispatch(sessionActions.createInitAction());
        }
        dispatch(basketActions.createGetAction());
    }, []);
    useEffect(() => {
        sessionState.authorities && !shouldRender && setShouldRender(true);
    }, [sessionState, shouldRender]);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        basketBasicRefetch();
        const scroll = () => __awaiter(void 0, void 0, void 0, function* () {
            yield mimicDelay(DELAY.DELAY_0);
            ScrollUtil.scrollToTop();
        });
        scroll();
    }, [pathname]);
    useEffect(() => {
        if (!(basketBasic === null || basketBasic === void 0 ? void 0 : basketBasic.basketId)) {
            return;
        }
        const loadDeviceFingerPrintingScript = () => __awaiter(void 0, void 0, void 0, function* () {
            yield UseSaferpayDeviceFingerPrinting(saferpayConfig.deviceFingerPrinting.dfpBaseUrl, basketBasic.basketId, saferpayConfig.deviceFingerPrinting.instanceId);
        });
        loadDeviceFingerPrintingScript();
    }, [basketBasic === null || basketBasic === void 0 ? void 0 : basketBasic.basketId]);
    useEffect(() => {
        window.addEventListener('beforeunload', () => ScrollUtil.scrollToTop());
        return () => window.removeEventListener('beforeunload', () => ScrollUtil.scrollToTop());
    }, []);
    if (!shouldRender)
        return null;
    return (_jsx(CheckoutProvider, { config: props, children: _jsx(CheckoutDeliveryProvider, { children: _jsxs(CheckoutPaymentProvider, { children: [_jsx(Route, { exact: true, path: [`${root}buy.html`, `${rootWithLanguageSuffix}/buy.html`], render: () => (_jsxs(_Fragment, { children: [_jsx(LockedBasketNotificationMessage, {}), isNewAuth ? _jsx(CheckoutLoginContainerNewAuth, {}) : _jsx(CheckoutLoginContainer, {})] })) }), _jsx(Route, { exact: true, path: [
                            `${root}buy.html/${RoutePathname.DELIVERY}`,
                            `${rootWithLanguageSuffix}/buy.html/${RoutePathname.DELIVERY}`,
                        ], render: () => (_jsx(CheckoutLayoutContainer, { step: CheckoutStep.DELIVERY, children: _jsx(CheckoutDeliveryContainer, {}) })) }), _jsx(Route, { exact: true, path: [
                            `${root}buy.html/${RoutePathname.PAYMENT}`,
                            `${rootWithLanguageSuffix}/buy.html/${RoutePathname.PAYMENT}`,
                        ], render: () => (_jsx(CheckoutLayoutContainer, { step: CheckoutStep.PAYMENT, children: _jsx(CheckoutPaymentContainer, {}) })) })] }) }) }));
};
export default CheckoutContainer;
